module.exports = __webpack_public_path__ + "img/empty.14cc1461.png";